import { Card, CardContent, Typography } from "@mui/material";
import React from "react";

const index = (props: { formValue: any }) => {
  return <div className="grid grid-cols-2 gap-3">
    <Card>
      <CardContent>
        <Typography align="center" >Basic Info</Typography>
        <Typography><span className="font-bold">First Name</span>: {props.formValue?.firstName}</Typography>
        <Typography><span className="font-bold">Middle Name</span>: {props.formValue?.middleName}</Typography>
        <Typography><span className="font-bold">Last Name</span>: {props.formValue?.lastName}</Typography>
        <Typography><span className="font-bold">Gender</span>: {props.formValue?.gender}</Typography>
        <Typography><span className="font-bold">Birth Date</span>: {new Date(props.formValue?.dob).toDateString()}</Typography>
      </CardContent>
    </Card>
    <div className="">
      <Typography align="center">Addresses</Typography>
      <div className="grid grid-cols-2 gap-2">
        {props.formValue?.addresses?.map((address: any) => (
          <Card>
            <CardContent>
              <Typography><span className="font-bold">Address Type</span>: {address?.addressType}</Typography>
              <Typography><span className="font-bold">Value</span>: {address?.value}</Typography>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </div>;
};

export default index;
